module.exports = __webpack_public_path__ + "bdf28e885e4bf55fa078fd8f0e8f7a76.png";